import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { Link } from 'react-router';
import { api } from '../lib/api';
import { meKey, useMe } from '../lib/session';
import { applyTheme, getTheme, type ThemeChoice } from '../lib/theme';
import { Brand } from '../ui/brand';
import { Button } from '../ui/controls';

/** Spieler-Portal: keine Seitenleiste, schmale zentrierte Spalte mit Wortmarke (design.md §5). */
export function PortalLayout({ children }: { children: ReactNode }) {
  const me = useMe();
  const qc = useQueryClient();
  const [theme, setTheme] = useState<ThemeChoice>(getTheme());
  const logout = useMutation({
    mutationFn: () => api.post('/web/auth/logout'),
    onSuccess: () => qc.setQueryData(meKey, null),
  });

  return (
    <div className="portal">
      <header className="portal-head">
        <Link to="/" className="brand-link">
          <Brand />
        </Link>
        <div className="row-actions">
          {me.data?.isAdmin && <Link to="/admin">Admin</Link>}
          <select
            aria-label="Darstellung"
            value={theme}
            onChange={(e) => {
              const v = e.target.value as ThemeChoice;
              setTheme(v);
              applyTheme(v);
            }}
          >
            <option value="system">System</option>
            <option value="light">Hell</option>
            <option value="dark">Dunkel</option>
          </select>
          {me.data && (
            <Button variant="quiet" onClick={() => logout.mutate()} busy={logout.isPending} busyText="Abmelden…">
              Abmelden
            </Button>
          )}
        </div>
      </header>
      {children}
      {/* Pflichthinweis nach Mojangs Nutzungsrichtlinien; Wortlaut auch auf Englisch (Prüfung der Microsoft-App) */}
      <footer className="portal-foot">
        <p>
          Kein offizielles Minecraft-Produkt. Nicht von Mojang oder Microsoft genehmigt oder mit ihnen verbunden.
          <br />
          <span lang="en">NOT AN OFFICIAL MINECRAFT PRODUCT. NOT APPROVED BY OR ASSOCIATED WITH MOJANG OR MICROSOFT.</span>
        </p>
        <p>
          <a href="https://lrtv.dev/impressum.html">Impressum</a> · <Link to="/datenschutz">Datenschutz</Link>
        </p>
      </footer>
    </div>
  );
}
